import React from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  icon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
}));

interface IProps {
  icon: React.ReactNode;
  tooltipText: string;
  placement?: TooltipProps['placement'];
}

export type AllProps = IProps;

export const IconWithTooltip: React.FC<AllProps> = (props) => {
  const classes = useStyles();

  return (
    <Tooltip title={props.tooltipText} placement={props.placement || 'bottom'} arrow>
      <div className={classes.icon}>
        {props.icon}
      </div>
    </Tooltip>
  );
};

export default IconWithTooltip;

